import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconAnimationUndershoot: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconAnimationUndershoot"><Path d="M3.5 15.1875C4.06667 17.3125 4.06667 20.5 6.33333 20.5C10.8667 20.5 9.16667 3.5 20.5 3.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconAnimationUndershoot;
